import "./styles.scss";

import { useTranslation } from "react-i18next";

import { useNotifications } from "context/notifications";

import Switch from "components/form/Switch";

const mainClass = "notifications-actions";

const NotificationsActions = () => {
  const { t } = useTranslation();
  const { readHandler, show_read, setShowRead } = useNotifications();

  return (
    <div className={mainClass}>
      <div>
        <Switch
          label={t("Show read")}
          checked={!!show_read}
          onChange={(e) => setShowRead(e?.target?.checked)}
        />
      </div>
      <div>
        <button type="button" onClick={() => readHandler("all")}>
          {t("Mark all as read")}
        </button>
      </div>
    </div>
  );
};

export default NotificationsActions;
